<template>
    <div>
        <b-img :src="require('../../assets/13.jpg')" fluid alt="Responsive image" />
        <b-container>
            <h2 class="mt-4">SUPERSTAR DJ, HERE WE GO!</h2>
            <p>Get ready to receive a text message with confirmation of your set.</p>
            <p>Make sure you keep an eye on your phone or you will miss your chance!</p>
            <b-row class="mt-4" style="text-align: center">
                <b-col>
                    <b-button to="/share" variant="default" block>
                        Share My Set
                    </b-button>
                </b-col>
                <b-col>
                    <b-button to="/set" variant="default" block>
                        View My Set
                    </b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>

</template>

<script>
    import { EventBus } from "../../EventBus";
    import _ from 'lodash';

    export default {
        name: "ConfirmationView",
        data() {
            return {
                trackList: '',
                tempTracks: []
            }
        },
        mounted() {
            EventBus.$emit('loading-show');
            this.$axios.get(`booking/email/${this.$store.state.user.email}`).then(result => {
                EventBus.$emit('loading-hide');
                const resTracks = result.data.tracks;
                _.forEach(resTracks, (track) => {
                    this.tempTracks.push(processTrackToOneLine(track));
                });
                let uls = '';
                _.forEach(this.tempTracks, (track) => {
                    uls = uls + `${track}, `;
                });
                this.trackList = uls;
            }).catch(() => {
                EventBus.$emit('loading-hide');
                EventBus.$emit('message', {message: 'Oops this isn’t working, don’t worry please show your host to resolve it', type: 'danger'});
            });
        }
    }

    function processTrackToOneLine(obj) {
        return `${obj.artist} - ${obj.track}`;
    }
</script>

<style scoped>

</style>
